// import React, { useState, useContext } from 'react';
// import noteContext from './Context/NoteContext';

// export default function ExpenseList() {

//       const {
//         expenseList, setExpenseList,
//         categories, setCategories,
//         isModal, setisModal,
//         modalType, setModalType,
//         edittmp, setedittmp,
//         ind, setind,
//         allCat, setAllCat,
//         addExpense, deleteExpense, updateExpense,
//         openModal, closeModal, setmodalTypeAndOpen
//       } = useContext(noteContext);

//     /* Delete button Function */

//     function del(index) {
//         if (window.confirm("are you sure?")) {
//             const dt = expenseList.filter((item, i) => i !== index)
//             setExpenseList(dt)
//         }
//     }

//     /* Delete button Function */

//     /* Edit button click Function */

//     function edit(index) {
//         setModalType("Edit")
//         setisModal(true)
//         const tp = { ...expenseList[index] }
//         setedittmp(tp)
//         setind(index)

//     };

//     /* Edit button click Function */


//     return (
//         <>
//             {/* Transctions List Rendering */}

//             <table className="table">
//                 <thead>
//                     <tr>
//                         <td>sr</td>
//                         <td>Amount</td>
//                         <td>Catagory</td>
//                         <td>type</td>
//                         <td>date</td>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {expenseList && expenseList.map((item, index) => {
//                         return (
//                             <tr key={index}>
//                                 <td>{index + 1}</td>
//                                 <td>{item.amount}</td>
//                                 <td>{item.category.name}</td>
//                                 <td className={item.type==="Income"?"exp":"inc"}>{item.type}</td>
//                                 <td>{item.date}</td>
//                                 <td><button className="delEditBtn" onClick={() => del(index)}>Delete</button></td>
//                                 <td><button className="delEditBtn" onClick={() => edit(index)}>Edit</button></td>
//                             </tr>
//                         )
//                     })}
//                 </tbody>
//             </table>

//             {/* Transctions List Rendering */}
//         </>
//     )
// }



import React, { useContext } from 'react';
import noteContext from './Context/NoteContext';
import { FiDelete } from 'react-icons/fi';
import { BiEdit, BiEditAlt, BiTrash } from 'react-icons/bi';

export default function ExpenseList() {
    const {
        expenseList, setExpenseList,
        setisModal,
        setModalType,
        setedittmp,
        setind,
        searchQuery,
        setSearchQuery,
        categories, setCategories,
        selectedCurrency
    } = useContext(noteContext);

    const filteredList = expenseList.filter((item) => {
        const query = searchQuery.toLowerCase();
        return (
            item.description?.toLowerCase().includes(query) ||
            item.category?.name?.toLowerCase().includes(query)
        );
    });

    function del(index) {
        if (window.confirm("are you sure?")) {
            const dt = expenseList.filter((item, i) => i !== index);
            setExpenseList(dt);
        }
    }

    function edit(index) {
        setModalType("Edit");
        setisModal(true);
        const tp = { ...expenseList[index] };
        setedittmp(tp);
        setind(index);
    }

    const clearSearch = () => setSearchQuery("");

    return (
        <div className="transactionContainer">
            {searchQuery && (
                <div style={{ marginBottom: '10px', fontSize: '14px', color: '#555' }}>
                    Showing results for "<b>{searchQuery}</b>"
                    <button onClick={clearSearch} style={{ marginLeft: '10px', cursor: 'pointer', border: 'none', background: 'none', color: '#007bff' }}>✕ Clear</button>
                </div>
            )}
            {/* Desktop Transctions Table */}
            <table className="table">
                <thead>
                    <tr>
                        <td>sr</td>
                        <td>Amount</td>
                        <td>Category</td>
                        <td>type</td>
                        <td>date</td>
                        <td>Description</td>
                        <td>Delete</td>
                        <td>Edit</td>
                    </tr>
                </thead>
                <tbody>
                    {filteredList.map((item, index) => {
                        const originalIndex = expenseList.findIndex(x => x === item);

                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.amount}</td>
                                <td>{item.category?.name}</td>
                                <td className={item.type === "Income" ? "inc" : "exp"}>{item.type}</td>
                                <td>{item.date}</td>
                                <td>{item.description}</td>
                                <td><button className="delEditBtn" onClick={() => del(originalIndex)}>Delete</button></td>
                                <td><button className="delEditBtn" onClick={() => edit(originalIndex)}>Edit</button></td>
                            </tr>

                        );
                    })}
                </tbody>
            </table>
            {/* Desktop Transctions Table */}


            {filteredList.map((item, index) => {
                const originalIndex = expenseList.findIndex(x => x === item);

                return (
                    <div className="transctionCard">
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <div style={{display:"flex", gap:"5px"}}>
                                <div className="iconCircle">{item.category.icon}</div>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ color: item.type === "Expense" ? "#8B0000" : "#006400", fontWeight: "bold" }}>{selectedCurrency.symbol}{item?.amount}</div>
                                    <div style={{ fontSize: "0.5em" }}>
                                        <div>{item?.category?.name}</div>
                                        <div>type: {item?.type}</div>
                                    </div>
                                </div>
                            </div>
                            <div style={{display:"flex", alignItems:"center", flexDirection:"column",gap:"2px"}}>
                                <div style={{ fontSize: "0.6em" }}>{item?.date}</div>
                                <div style={{ display: "flex", gap: "8px" }}>
                                    <span onClick={() => del(originalIndex)} className="editDelCircle"><BiTrash size={20} /></span>
                                    <span onClick={() => edit(originalIndex)} className="editDelCircle"><BiEditAlt size={20} /></span>
                                </div>
                            </div>
                        </div>
                        <div style={{ fontSize: "0.7em", fontWeight: "bold" }}>Desc:{item?.description}</div>
                    </div>
                );
            })}



            {filteredList.length === 0 && searchQuery && (
                <div style={{ textAlign: 'center', marginTop: '20px', color: '#888' }}>
                    <p>No transactions match your search.</p>
                </div>
            )}
        </div>
    );
}